import React, { useState } from 'react';

// Detect known in-app browsers where PWA install and magic links won't work
function detectInAppBrowser() {
  const ua = navigator.userAgent;
  if (/FBAN|FBAV|FB_IAB/.test(ua)) return 'Facebook';
  if (/Instagram/.test(ua)) return 'Instagram';
  if (/LinkedInApp/.test(ua)) return 'LinkedIn';
  if (/Twitter/.test(ua) && !/Chrome/.test(ua)) return 'Twitter';
  return null;
}

const inAppSource = detectInAppBrowser();

export default function InAppBrowserBanner() {
  const [dismissed, setDismissed] = useState(false);

  if (!inAppSource || dismissed) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
      background: '#7C3C00', color: 'white',
      padding: '12px 16px',
      display: 'flex', alignItems: 'flex-start', gap: 10,
      boxShadow: '0 2px 12px rgba(0,0,0,0.3)',
    }}>
      <span style={{ fontSize: 20, flexShrink: 0 }}>⚠️</span>
      <div style={{ flex: 1, fontSize: '0.95rem', lineHeight: 1.4 }}>
        <strong>You're using the {inAppSource} browser.</strong> To sign in or install this app, open it in Safari — tap the menu (
        <strong>···</strong> or <strong>⋮</strong>) and choose <strong>Open in Safari</strong>.
      </div>
      <button
        onClick={() => setDismissed(true)}
        style={{ background: 'none', border: 'none', color: 'white', fontSize: '1.2rem', cursor: 'pointer', padding: 0, flexShrink: 0, opacity: 0.8 }}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
}
